import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { TourBookingsList } from './TourBookingsList'

export const PaymentHistoryStatistics: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="h5" mb={2}>{t('payment.statistics')}</Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TourBookingsList />
        </Grid>
      </Grid>
    </Box>
  )
}
